export enum ReportType {
  Null = "null",
  AgedReceivables = "aged-receivables",
  IncomeByCustomer = "income-by-customer",
  SalesTaxReport = "sales-tax-report",
  PaymentsTaxReport = "payments-tax-report",
}
